import { useState } from 'react'
import * as XLSX from 'xlsx';
import ExcelData from './ExcelData';
import { executeLaravelFrontAPI } from '../../Utils';
import Cookies from 'js-cookie';
import ExcelUploadForm from './ExcelUploadForm';

function UploadExcelFile() {
    const [excelFile, setExcelFile] = useState(null);
    const [formError, setformError] = useState({});
    const [locationData, setLocationData] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState("");
    const handleLocationChange = (e) => {
        setSelectedLocation(e.target.value);
    }
    // list
    const [excelData, setExcelData] = useState(null);

    const [developerData, setDeveloperData] = useState([]);
    const [selectedDeveloper, setSelectedDeveloper] = useState('')
  
    const handleFile = (e) => {
        const fileType = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.oasis.opendocument.spreadsheet'];
        const file = e.target.files[0];
        if (file) {
            if (file && fileType.includes(file.type)) {

                let reader = new FileReader();
                reader.readAsArrayBuffer(file);

                reader.onload = (e) => {
                    setExcelFile(e.target.result);
                }

                setformError({});
            } else {
                setExcelFile(null);
                setformError({ file: "Please upload a valid Excel file." });// not a excel file
            }
        } else {
            console.error("No file selected");
        }
    }



    const extractReraFromAPI = (value) => {
        if (!value) return null;
        try {
            const parsed = JSON.parse(value); // → [["P52100046175"]]
            return parsed?.[0]?.[0] || null;  // → "P52100046175"
        } catch {
            return null;
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        let errors = {};

        if (!selectedLocation) {
            errors.location = "Please select a location.";
        }

        if (!excelFile) {
            errors.file = "Please upload an Excel file.";
        }
        setformError(errors);

        if (Object.keys(errors).length > 0) {
            return;
        }

        const workbook = XLSX.read(excelFile, { type: "buffer" });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];

        const excelJson = XLSX.utils.sheet_to_json(worksheet);

        try {
            let paramsData = {};
            paramsData.city = Cookies.get("selectedCityCookie") || "pune";
            paramsData.per_page = 1000
            paramsData.page = 1;
            paramsData.locality_name = selectedLocation
            paramsData.searchtype = 'locality_name'

            const result = await executeLaravelFrontAPI('projects', paramsData, 'GET');
            // API response list
            const apiProjects = result?.data?.data || [];
            // Extract only RERA numbers into list
            const apiReraList = apiProjects.map(item => extractReraFromAPI(item.rera_registration_no)).filter(rera => rera !== null);
            // ---- Add Status Flag into each Excel Row ----
            const mergedData = excelJson.map(row => ({
                ...row,
                Status: apiReraList.includes(row["RERA Registration No"])
                    ? "Already Exists"
                    : "New Project"
            }));

            setExcelData(mergedData);

        } catch (error) {
            console.log("API Error:", error);
        }
    };



    return (
        <>
            <ExcelUploadForm handleFile={handleFile}
                handleSubmit={handleSubmit}
                locationData={locationData}
                setLocationData={setLocationData}
                selectedLocation={selectedLocation}
                setSelectedLocation={setSelectedLocation}
                handleLocationChange={handleLocationChange}
                formError={formError}
                developerData={developerData}
                setDeveloperData={setDeveloperData}
                selectedDeveloper={selectedDeveloper}
                setSelectedDeveloper={setSelectedDeveloper}

            />
            <br />
            {/* show data in table formate */}
            {
                excelData && excelData.length > 0 && (
                    <div className='box'>

                        <div className="box-header with-border">
                            <h3 className="box-title">Excel File Data</h3>
                        </div>



                        <div className="box-body">
                            <div className="box-body table-container mt-4 hr-scroll-style">
                                {excelData && excelData.length > 0 && (
                                    <table className='table table-resposive table-hover dashboard-table shadow-sm mb-0'>
                                        <thead>
                                            <tr>
                                                <th>Project Name</th>
                                                <th>RERA Registration No</th>
                                                <th>Locality Name</th>
                                                <th>City</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>

                                        <tbody>

                                            <ExcelData excelData={excelData} />
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>

                    </div>
                )
            }


        </>

    )
}

export default UploadExcelFile